var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flightcard-debugger-container"},[_c('div',{staticClass:"flightcard-debugger-inner-container"},[_c('span',[_vm._v(_vm._s(_vm.infos.channel))]),_c('span',[_vm._v(_vm._s(_vm.infos.identifier))]),_c('span',[_vm._v(_vm._s(_vm.infos.debugger))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }